import React, { useEffect } from 'react';
import '../styles/Webservice.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaCode, FaPaintBrush, FaServer, FaMobileAlt, FaPenNib } from 'react-icons/fa';

import image1 from '../assets/webdevelep.jpg';
import image2 from '../assets/ui.avif';
import image3 from '../assets/hosting.jpg';
import image4 from '../assets/responsive.jpg';
import image5 from '../assets/cs7.jpg';
import parallaxImg from '../assets/bg9.jpg';


const Webservice = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="webservice-container">
      {/* 1. Quality Web Development */}
      <div className="webservice-section" >
        <div className="webservice-box" data-aos="fade-right">
          <FaCode className="webservice-icon" />
          <h3>Quality Web Development</h3>
          <p>We specialize in crafting high-performance websites that are fast, secure, and fully responsive. Our development process focuses on clean code, modern frameworks, and scalable architecture to ensure long-term success. Whether it’s a business site, e-commerce platform, or custom web application, we deliver solutions that are optimized for user experience and built to grow with your brand.</p>
        </div>
        <div className="webservice-image" data-aos="fade-left" style={{ backgroundImage: `url(${image1})` }} />
      </div>

      {/* 2. UI/UX Design Services */}
      <div className="webservice-section" >
        <div className="webservice-image" data-aos="fade-right" style={{ backgroundImage: `url(${image2})` }} />
        <div className="webservice-box" data-aos="fade-left">
          <FaPaintBrush className="webservice-icon" />
          <h3>UI/UX Design Services</h3>
          <p>We create seamless and engaging digital experiences through thoughtful UI/UX design. From wireframes to high-fidelity prototypes, our design process prioritizes usability, accessibility, and visual appeal. Every element is crafted to guide users intuitively, ensuring a smooth journey across your website or application. Our goal is to turn complex ideas into beautiful, functional interfaces that leave a lasting impression.</p>
        </div>
      </div>

      {/* 3. Web Hosting */}
      <div className="webservice-section" >
        <div className="webservice-box" data-aos="fade-right">
          <FaServer className="webservice-icon" />
          <h3>Web Hosting</h3>
          <p>Our web hosting services provide a secure, fast, and reliable foundation for your online presence. With 99.9% uptime, advanced security protocols, and scalable infrastructure, we ensure your website remains accessible and performs optimally around the clock. Whether you're launching a startup site or managing high-traffic platforms, our hosting solutions are built to support growth and deliver consistent performance.</p>
        </div>
        <div className="webservice-image" data-aos="fade-left" style={{ backgroundImage: `url(${image3})` }} />
      </div>

      {/* 4. Responsive Services */}
      <div className="webservice-section">
        <div className="webservice-image"  data-aos="fade-right" style={{ backgroundImage: `url(${image4})` }} />
        <div className="webservice-box" data-aos="fade-left">
          <FaMobileAlt className="webservice-icon" />
          <h3>Mobile & Tablet Responsive</h3>
          <p>We design and develop websites that adapt seamlessly to any screen size—from smartphones to tablets—ensuring a flawless user experience across all devices. Our responsive design approach guarantees fast loading times, intuitive navigation, and visually appealing layouts, helping you engage your audience effectively whether they're browsing on the go or at home.</p>
        </div>
      </div>

      {/* 5. Logo Design */}
      <div className="webservice-section">
        <div className="webservice-box"  data-aos="fade-right">
          <FaPenNib className="webservice-icon" />
          <h3>Logo Design</h3>
          <p>Your logo is the face of your brand, and we craft designs that are both memorable and meaningful. Our logo design process blends creativity with strategy to create distinctive identities that reflect your brand’s values, resonate with your audience, and stand out in a crowded marketplace. Whether you're launching a new venture or rebranding, we deliver logos that leave a lasting impression.</p>
        </div>
        <div className="webservice-image" data-aos="fade-left" style={{ backgroundImage: `url(${image5})` }} />
      </div>
      <div className="parallax-container">
  <div
    className="parallax-background"
    style={{ backgroundImage: `url(${parallaxImg})` }}
  />
  
  <div className="parallax-overlay">
    <h1 className="parallax-heading">GROW YOUR BUSSINESS</h1>
  </div>
</div>
    </div>
    
  );
};

export default Webservice;
